import { ReactNode, CSSProperties } from "react";

export function ModalHeader({
  children,
  className,
  style,
}: {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`[&_.heading]:block [&_.heading]:font-dm-sans [&_.heading]:text-2xl [&_.heading]:font-black [&_.heading]:leading-[110%] [&_.heading]:tracking-[0em] [&_.heading]:whitespace-pre-line [&_.heading]:text-center [&_.disclaimer-corner]:absolute [&_.disclaimer-corner]:-top-[23px] [&_.disclaimer-corner]:right-[17px] [&_.disclaimer-corner]:bg-white [&_.disclaimer-corner]:h-[46px] [&_.disclaimer-corner]:w-[46px] [&_.disclaimer-corner]:rounded-[100px] [&_.disclaimer-corner]:shadow-card [&_.disclaimer-corner]:flex [&_.disclaimer-corner]:items-center [&_.disclaimer-corner]:justify-center ${className ?? ""}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function ModalContent({
  children,
  className,
  style,
}: {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`flex-1 max-h-[60dvh] overflow-y-auto w-full whitespace-pre-line leading-[1.4] ${className ?? ""}`}
      style={style}
    >
      {children}
    </div>
  );
}

export function ModalActions({
  children,
  className,
  style,
}: {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`flex items-center justify-center gap-[10px] ${className ?? ""}`}
      style={style}
    >
      {children}
    </div>
  );
}
